<template>
    <img
        :src="path"
        class="help-icon"
        alt="Help"
        @click.prevent.stop="action"
    >
</template>

<script>
export default {
    props: ['action'],
    computed: {
        path() {
            const path = 'images/icons/help.svg';

            if (this.$root.appBasePath) {
                return `/${this.$root.appBasePath}/${path}`;
            }

            return `/${path}`;
        },
    },
};
</script>
